import router from 'router';

function persistCreateWebhook(data) {
    return {
        ...data,
        configuration: data.configuration
            .filter(event => event.is_enabled || (!_.isNil(event.channel) && event.channel.length))
            .map(({label, ...event}) => {
                return {
                    id: event.id,
                    is_enabled: event.is_enabled,
                    ...event.channel && {channel: event.channel}
                }
            })
    }
}

function persistUpdateWebhook(data) {
    const persist = {
        is_enabled: data.is_enabled,
        name: data.name,
        endpoint: data.endpoint,
        configuration: data.configuration
            .filter(event => event.is_enabled || (!_.isNil(event.channel) && event.channel.length))
            .map(({ label, ...event }) => {
                return {
                    id: event.id,
                    is_enabled: event.is_enabled,
                    ...event.channel && {channel: event.channel}
                }
            })
    };
    if (data.type === 'http') {
        persist.object_in_payload = data.object_in_payload;
        persist.json_content_type = data.json_content_type;
        persist.sign_key = data.sign_key;
    }
    if(!_.isNil(data.default_channel)) {
        persist.default_channel = data.default_channel;
    }

    return persist;
}
export default {
    getWebhooks(params) {
        return window.ApiClient.get(
            router.resolve({ name: 'webhooks.list' }).href,
            params
        );
    },

    createWebhook(data) {
        return window.ApiClient.post(
            router.resolve({ name: 'webhooks.list'}).href,
            null,
            persistCreateWebhook(data)
        );
    },

    getWebhook(id) {
        return window.ApiClient.get(
            router.resolve({ name: 'webhooks.single', params: { id } }).href
        );
    },

    updateWebhook(id, data) {
        return window.ApiClient.put(
            router.resolve({ name: 'webhooks.single', params: { id } }).href,
            null,
            persistUpdateWebhook(data)
        );
    },

    deleteWebhook(id) {
        return window.ApiClient.del(
            router.resolve({ name: 'webhooks.single', params: { id } }).href,
        );
    },

    getEvents() {
        return window.ApiClient.get(
            router.resolve({ name: 'webhooks.events'}).href,
        );
    }
}
